export enum ProfileApplication {
  DESENVOLVIMENTO,
  HOMOLOG,
  PROD,
  LOCAL,
}

const getEnumDescription = (enumValue: ProfileApplication): string => {
  return ProfileApplication[enumValue];
};

export { getEnumDescription };
